<template>
  <div class="component-content sub-content">
    <!-- <div class="list-title">
      <div class="r">
        <el-button type="primary" @click="startCreate()" size="mini">上传文件</el-button>
      </div>
    </div> -->

    <el-col :span="24">
      <div class="contacts-tree">

        <!-- <el-button  @click="openFolder(this.fatherFolderId, 'back')" style="margin:10px 0;" size="mini" type="primary">返回上一级</el-button> -->

        <el-button @click="append(nowFolderId)" v-if="backRole('WJ_1')" style="margin:10px 0;" size="mini"
          type="primary">
          新建文件夹</el-button>

        <el-upload style="display:inline;" class="upload-demo" v-if="backRole('WJ_1') && nowFolderId" :show-file-list="false"
          :before-upload="handleBeforeUpload" :action="uploadUrl" multiple :on-success="handleAvatarSuccess">
          <el-button @click="setFolderId()" icon="el-icon-plus" type="primary" v-loading="isUpload"
            size="mini">
            上传文件
          </el-button>
        </el-upload>

        <el-button @click="setAuth()" style="margin:10px 0;" size="mini" type="primary">设置访问权限</el-button>

        <div class="disk-nav">
          <label>当前：</label>
          <a href="javascript:;" v-for="item,i in folderArr" :key="i" @click="openFolder(item, i+1)">
            {{ item.name }}
          </a>
        </div>

        <el-table ref="multipleTable" :data="paginationData" style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
          <el-table-column type="selection" :selectable='isDisabled' disabled="true" width="40"></el-table-column>
          <el-table-column label="文件名">
            <template slot-scope="scope">
              <a v-if="scope.row.type=='0'" href="javascript:;" class="link" @click="openFolder(scope.row)">
                <i class="iconfont icon-wenjianjia"></i>
                {{ scope.row.name }}
              </a>
              <span v-else>
                <i class="iconfont icon-link"></i>
                <file-link :item="scope.row"></file-link>
              </span>

            </template>
          </el-table-column>

          <el-table-column label="操作" align="right" width="">
            <template slot-scope="scope">
              <span v-if="scope.row.type=='0'">
                <el-tooltip class="item" effect="dark" content="重命名" placement="bottom">
                  <el-button icon="el-icon-edit" type="success" circle size="" @click="() => edit(scope.row)"
                    @click.stop></el-button>
                </el-tooltip>

                <el-tooltip class="item" effect="dark" content="删除文件夹" placement="bottom">
                  <el-button icon="el-icon-close" type="danger" circle size="" @click="() => remove(scope.row)"
                    @click.stop></el-button>
                </el-tooltip>
              </span>

              <span v-else class="disk-btn">
                <el-tooltip class="item" effect="dark" content="下载文件" placement="bottom">
                  <a :href="baseUrl+'/common/file/download?dz='+scope.row.fileUrl" target="_blank">
                    <el-button type="primary" icon="el-icon-download" circle size=""></el-button>
                  </a>
                </el-tooltip>

                <span v-if="scope.row.creator.id==userData.id">
                  <el-tooltip class="item" effect="dark" content="重命名" placement="bottom">
                    <el-button icon="el-icon-edit" type="success" circle size="" @click="() => edit(scope.row, 1)"
                      @click.stop></el-button>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="删除文件" placement="bottom">
                    <el-button icon="el-icon-close" type="danger" circle size="" @click="() => removeFile(scope.row)"
                      @click.stop></el-button>
                  </el-tooltip>
                </span>
              </span>
              <!--               
              <div class="custom-tree-node" v-if="!data.type">
                <span>{{ node.label }}</span>
                <span class="disk-btn" v-if="backRole('WJ_1')">
                  <div @click.stop class="file-upload">
                    <el-upload class="upload-demo" :show-file-list="false" :before-upload="handleBeforeUpload"
                      :action="uploadUrl" multiple :on-success="handleAvatarSuccess">
                      <el-button @click="setFolderId(node,data)" icon="el-icon-plus" type="primary" v-loading="isUpload"
                        size="mini">
                        上传文件
                      </el-button>
                    </el-upload>
                  </div>

                  <el-button icon="el-icon-plus" type="primary" size="mini" @click="() => append(data)" @click.stop>子文件夹
                  </el-button>

                  
                </span>
              </div> -->

            </template>
          </el-table-column>
        </el-table>
        <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
          :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
          @current-change="handleCurrentChange">
        </el-pagination>

        <!-- <el-tree class="disk-type-room" :data="treeListData" :props="defaultProps" show-checkbox default-expand-all
          node-key="id" ref="fileTree" v-loading="formLoading">

          <div class="custom-tree-node" slot-scope="{ node, data }">

            <div class="custom-tree-node" v-if="!data.type">
              <span>{{ node.label }}</span>
              <span class="disk-btn" v-if="backRole('WJ_1')">
                <div @click.stop class="file-upload">
                  <el-upload class="upload-demo" :show-file-list="false" :before-upload="handleBeforeUpload"
                    :action="uploadUrl" multiple :on-success="handleAvatarSuccess">
                    <el-button @click="setFolderId(node,data)" icon="el-icon-plus" type="primary" v-loading="isUpload"
                      size="mini">
                      上传文件
                    </el-button>
                  </el-upload>
                </div>

                <el-button icon="el-icon-plus" type="primary" size="mini" @click="() => append(data)" @click.stop>子文件夹
                </el-button>

                <span>
                  <el-tooltip class="item" effect="dark" content="重命名" placement="bottom">
                    <el-button icon="el-icon-edit" type="success" circle size="mini" @click="() => edit(data)"
                      @click.stop></el-button>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="删除文件夹" placement="bottom">
                    <el-button icon="el-icon-close" type="danger" circle size="mini" @click="() => remove(node, data)"
                      @click.stop></el-button>
                  </el-tooltip>
                </span>
              </span>
            </div>
            <div class="custom-tree-node" v-else>
              <file-link :item="data"></file-link>


              <span class="disk-btn">
                <el-tooltip class="item" effect="dark" content="下载文件" placement="bottom">
                  <a :href="baseUrl+'/common/file/download?dz='+data.fileUrl" target="_blank">
                    <el-button type="primary" icon="el-icon-download" circle size="mini"></el-button>
                  </a>
                </el-tooltip>

                <span v-if="data.creator.id==userData.id">
                  <el-tooltip class="item" effect="dark" content="重命名" placement="bottom">
                    <el-button icon="el-icon-edit" type="success" circle size="mini" @click="() => edit(data, 1)"
                      @click.stop></el-button>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="删除文件" placement="bottom">
                    <el-button icon="el-icon-close" type="danger" circle size="mini"
                      @click="() => removeFile(node, data)" @click.stop></el-button>
                  </el-tooltip>
                </span>
              </span>
            </div>

          </div>

        </el-tree> -->





        <!-- 通讯录树形结构 -->
        <!-- <el-tree :data="treeListData" :props="defaultProps" node-key="depId" @node-click="handleNodeClick"
            :default-expanded-keys="[1]"></el-tree> -->
      </div>
    </el-col>

    <!-- 重命名 -->
    <div class="pop-room" v-if="addDiskStatus">
      <a href="javascript:;" @click="addDiskStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="form" :model="form" label-width="120px" class="form" @submit.native.prevent>
            <el-form-item :label="labelName">
              <el-input v-model="form.name" @keyup.enter.native="CreateFolder()"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-button :loading="formLoading" @click="CreateFolder()" class="form-btn" type="success">确认提交</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>

    <!-- 设置权限 -->
    <div class="pop-room" v-if="setAuthStatus">
      <a href="javascript:;" @click="setAuthStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="authForm" :model="authForm" label-width="120px" class="form" @submit.native.prevent>
            <el-form-item label="是否所有人可见">
              <el-radio-group size="mini" v-model="authFormType">
                <el-radio-button label="0">按权限设置</el-radio-button>
                <el-radio-button label="1">所有人可见</el-radio-button>
                <el-radio-button label="2">仅自己可见</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="权限设置" v-if="authFormType=='0'">
              <div class="dep-auth">
                <div class="contact-user-list">
                  <div class="user-item" v-for="user,j in depArr">
                    <span class="name">{{user.name}}</span>
                    <!-- <span @click="deleteDeps(j)" class="iconfont icon-close1"></span> -->
                  </div>
                </div>
                <el-button type="primary" @click="addDeps()" size="mini" icon="el-icon-plus">设置公司/部门权限</el-button>
              </div>
              <div class="user-auth">
                <div class="contact-user-list">
                  <div class="user-item" v-for="user,j in selectArr">
                    <span class="name">{{user.name}}</span>
                    <span @click="deleteUsers(j)" class="iconfont icon-close1"></span>
                  </div>
                </div>
                <el-button @click="addUsers()" type="primary" size="mini" icon="el-icon-plus">设置人员权限</el-button>
              </div>
            </el-form-item>
            <el-form-item label="">
              <el-button :loading="formLoading" @click="submitAuth()" class="form-btn" type="success">确认提交</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>

    <!-- 选择公司/部门 -->
    <div class="pop-room asset-type-pop" v-if="organizationListStatus">
      <a href="javascript:;" @click="organizationListStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-tree style="max-height:400px;overflow-y:auto;" :data="organizationList" show-checkbox
            :props="organizationProps" node-key="id" ref="organizationTree">
          </el-tree>
          <el-button size="mini" @click="organizationSelectSuccess()" type="primary" style="margin:15px 0 0 25px;">确认选择
          </el-button>
        </el-col>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import FileLink from '@/components/FileLink'
  import UserInfo from '@/components/UserInfo'
  import Role from '@/Mixins/role'

  export default {
    components: {
      UserInfo,
      FileLink,
    },
    mixins: [Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
        isMobile: state => state.main.isMobile,
      })
    },
    data() {
      return {
        organizationListData: [],
        noSelectOrganization: true,
        depId: '',

        // 当前的FolderId
        folderArr: [{
          name: '全部文件',
          id: ''
        }],
        nowFolderId: '',
        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
        multipleSelection:[],


        // 增加/修改 分类
        addDiskStatus: false,
        nowUpdateType: '',
        labelName: "文件夹名称",
        // loading状态
        formLoading: false,
        formType: 'create',
        // 添加文件夹
        form: {
          depId: "",
          name: "",
          parentId: ""
        },
        defaultProps: {
          children: 'childs',
          label: 'name'
        },

        // 上传文件
        isUpload: false,
        baseUrl: axios.defaults.baseURL,
        uploadUrl: axios.defaults.baseURL + '/common/upload',
        fileForm: {
          fileName: "",
          fileSize: "",
          fileUrl: "",
          folderId: ""
        },
        // 批量上传延迟时间,毫秒
        updateTree: '',
        lateTime: 500,

        // 目录数据
        // treeListData: [],

        // 访问权限
        // 所有人可见
        authFormType: "1",
        selectFiles: [],
        authForm: {
          depIds: "",
          fileIds: "",
          userIds: "",
        },
        setAuthStatus: false,
        // 设置人员权限
        selectArrIndex: "",
        selectArr: [],
        // 设置部门权限
        depArrIndex: "",
        depArr: [],
        organizationListStatus: false,
        organizationList: [],
        organizationProps: {
          children: 'childDepts',
          label: 'name'
        },
        organizationCheck: {},

      }
    },
    created() {
      this.organizationList = this.organization[0].childDepts
      this.depId = this.userData.secDepIds.split(",")[0]
    },
    mounted() {
      // 获取文件柜Tree列表
      this.getTreeLists()
    },
    methods: {
      // 复选框勾选的内容
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 提交权限设置
      submitAuth() {
        switch (this.authFormType) {
          case '0':
            this.authForm.depIds = this.depArr.map(item => item.id).join()
            this.authForm.userIds = this.selectArr.map(item => item.id).join()
            break;
          case '1':
            this.authForm.depIds = ''
            this.authForm.userIds = ''
            break;
          case '2':
            this.authForm.depIds = ''
            this.authForm.userIds = this.userData.id
            break;
        }
        ajax.post('/disk/file/auth/edit', this.authForm, (res) => {
          this.$refs.fileTree.setCheckedNodes([])
          this.$message.success('权限设置成功')
          this.setAuthStatus = false
        })
      },
      // 权限设置
      setAuth() {
        this.selectFiles = []
        let _nodes = this.multipleSelection
        if (_nodes.length < 1) {
          this.$message.error('请选择需要设置权限的文件，再点击此按钮')
          return false
        } else {
          for (let i = 0; i < _nodes.length; i++) {
            if (_nodes[i].type == "file") {
              this.selectFiles.push(_nodes[i])
            }
          }
          this.authForm.fileIds = this.selectFiles.map(item => item.id).join()
          this.setAuthStatus = true
        }
      },
      // 设置人员权限
      addUsers() {
        let _sr = []
        _sr = this.selectArr ? this.selectArr : []
        this.$store.commit('set_contactSelectArr', _sr)
        this.$store.commit('set_contactShow', true)
        this.$store.commit('set_contactSingleSelect', false)
      },
      deleteUsers(index) {
        this.selectArr.splice(index, 1)
      },
      // 设置部门
      addDeps() {
        this.organizationListStatus = true
        if (this.depArr) {
          this.$nextTick(() => {
            this.$refs.organizationTree.setCheckedNodes(this.depArr)
          })
        }
      },
      // 确认选择公司/部门
      organizationSelectSuccess() {
        this.organizationListStatus = false
        this.depArr = this.$refs.organizationTree.getCheckedNodes()
      },
      deleteDeps(index) {
        this.depArr.splice(index, 1)
      },

      // 设置文件夹ID
      setFolderId() {
        this.fileForm.folderId = this.nowFolderId
      },
      // 上传文件相关
      handleBeforeUpload(file) {
        if (this.isUpload) {
          // return false
        } else {
          this.isUpload = true
        }
      },
      // 保存文件路径到文件柜
      appendFile() {
        ajax.post('/disk/file/add', this.fileForm, (res) => {
          clearTimeout(this.updateTree)
          this.updateTree = setTimeout(() => {
            // 刷新tree
            this.getTreeLists()

          }, this.lateTime)
        })
      },
      // 上传文件到服务器回调
      handleAvatarSuccess(res, file) {
        this.isUpload = false
        console.log('success')
        this.fileForm.fileName = res.vo.fileName
        this.fileForm.fileSize = res.vo.fileSize
        this.fileForm.fileUrl = res.vo.fileUrl
        this.appendFile()
      },
      // 添加/修改文件夹
      CreateFolder() {
        this.formLoading = true
        this.addDiskStatus = false
        this.form.depId = this.depId
        // 添加分类
        let _url = this.formType == 'create' ? "/disk/folder/add" : (this.nowUpdateType ? "/disk/file/name/edit" :
          "/disk/folder/name/edit")

        if (this.nowUpdateType) {
          this.form.fileId = this.form.folderId
          this.form.fileName = this.form.name
        }

        ajax.post(_url, this.form, (res) => {
          this.formLoading = false
          this.getTreeLists()
        })
      },
      // 显示添加文件夹弹窗
      append(filterId) {
        this.addDiskStatus = true
        this.formLoading = false
        this.formType = 'create'

        this.form.name = ""
        this.form.parentId = filterId
      },
      // 修改文件夹 / 文件
      edit(row, type) {
        this.addDiskStatus = true
        this.formLoading = false
        this.formType = 'edit'

        this.labelName = type ? '文件名称' : '文件夹名称'
        this.nowUpdateType = type

        this.form.name = row.name
        this.form.folderId = row.id
      },
      // 删除文件
      removeFile(row) {
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ajax.post('/disk/file/del', {
            'fileId': row.id,
          }, (res) => {
            this.$message.success('删除文件成功')
            this.getTreeLists()
          })
        }).catch(() => {});
      },
      // 删除文件夹
      remove(row) {
        this.$confirm('此操作将永久删除该文件夹, 且同时会删除其子文件夹与文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ajax.post('/disk/folder/del', {
            'folderId': row.id,
          }, (res) => {
            this.$message.success('删除文件夹成功')
            this.getTreeLists()
          })
        }).catch(() => {});
      },

      // 递归调整结构
      // treeDataRecursion(arr) {
      //   for (let i = 0; i < arr.length; i++) {
      //     let _item = arr[i]
      //     // 父文件夹
      //     _item.disabled = true
      //     for (let z = 0; z < _item.childs.length; z++) {
      //       // 子文件夹
      //       _item.childs[z].disabled = true
      //     }
      //     let _files = _item.files
      //     let _canSeeFiles = []
      //     for (let j = 0; j < _files.length; j++) {
      //       let _f = _files[j]
      //       if (_f.canSee) {
      //         _f.name = _f.fileName
      //         _f.type = 'file'
      //         _f.disabled = _f.creator.id != this.userData.id
      //         _canSeeFiles.push(_f)
      //       }
      //     }
      //     _item.childs = (this.treeDataRecursion(_item.childs)).concat(_canSeeFiles)
      //   }
      //   return arr
      // },

      // 点击进入文件夹
      openFolder(row, backIndex) {
        // 清空表格所选项目
        this.$refs.multipleTable.clearSelection();
        // 判断打开方式
        if (backIndex == '' || backIndex == undefined) {
          // 向下打开
          this.folderArr.push({
            name: row.name,
            id: row.id
          })
        } else {
          // 点击导航
          this.folderArr.splice(backIndex, this.folderArr.length - backIndex)
        }
        // 获取文件夹内容
        this.nowFolderId = row.id
        this.getTreeLists()
      },
      // 禁用文件夹的复选框，无权限的复选框
      isDisabled(row, index) {
        let _disabled = true
        if (row.type == '0') {
          _disabled = false
        }
        return _disabled
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterName)
        if (this.filterName) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.name.indexOf(this.filterName) != -1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getTreeLists() {
        this.loading = true

        ajax.get('/disk/folder/detail', {
          folderId: this.nowFolderId
        }, res => {
          this.loading = false
          let _array
          if (!res.vo.childs) {
            res.vo.childs = []
          }
          if (!res.vo.files) {
            res.vo.files = []
          }
          _array = res.vo.childs.concat(res.vo.files)
          this.filterData = this.listData = _array
          this.getFilterData()
        })
        // ajax.get('/disk/folder/tree', {}, (res) => {
        //   this.loading = false
        //   let _tree = res.vo.array
        //   this.treeListData = this.treeDataRecursion(_tree)
        // })
      },
    },
    watch: {}
  };
</script>


// WEBPACK FOOTER //
// src/page/disk/list.vue